import { forwardRef } from "react";
import type { AppIcon } from "../types";

export const DoubleArrowIcon = forwardRef<SVGSVGElement, AppIcon>(
  ({ width = 16, height = 16, ...props }, ref) => {
    return (
      <svg
        width={width}
        height={height}
        ref={ref}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M7.63636 3.5L4 8L7.63636 12.5M12 3.5L8.36364 8L12 12.5"
          stroke="#1677FF"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
);
